import clsx from 'clsx';
import React, { useState } from 'react';
import QuantityInput from '../Components/BuyButton/QuantityInput';
import BuyButton from '../Components/BuyButton/BuyButton';
import EnquiryButton from '../Components/BuyButton/EnquiryButton';
import { useDispatch } from 'react-redux';
import { add as addToCartService } from '../Services/Cart.service';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { ButtonStates } from '../constants';
import Icon from '../Components/Icon';
import { translate } from '../Services/translation';
import useIsAuthenticated from '../Hooks/useIsAuthenticated';
import { setLoginModalOpen } from '../Actions/Login.action';
import WishListButton from '../Components/WishList/WishListButton';
import { useIsBendixTheme } from '../Hooks/ChannelHooks';

const BuyButtonContainer = ({
  articleNumber,
  disabled,
  buyButtonLabel,
  buyButtonClassName,
  enquiryButtonLabel,
  wrapperClassName,
  showQuantityInput = true,
  packageSize,
  wishList,
  onChangeQuantity,
  allowBrokenBox = false,
  extendedStockStatus,
  stockQuantity: stockQuantityProp,
}) => {
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();
  const isBendix = useIsBendixTheme();
  const [quantity, setQuantity] = useState(packageSize);
  const [buyButtonState, setBuyButtonState] = useState(ButtonStates.Default);
  const [enquiryButtonState, setEnquiryButtonState] = useState(
    ButtonStates.Default
  );
  const [confirmedBrokenBoxQty, setConfirmedBrokenBoxQty] = useState(null);
  const stockQuantity =
    extendedStockStatus?.[0]?.inStockQuantity || stockQuantityProp || 0;
  const clearsRemainingStock = (qty) =>
    stockQuantity > 0 && qty >= stockQuantity;

  const updateQuantity = (newQuantity) => {
    setQuantity(newQuantity);
    if (parseInt(newQuantity) !== confirmedBrokenBoxQty) {
      setConfirmedBrokenBoxQty(null);
    }
    onChangeQuantity?.(newQuantity);
  };

  const performAddToCart = async (qty) => {
    try {
      setBuyButtonState(ButtonStates.Loading);

      const cart = await addToCartService({
        articleNumber,
        quantity: qty,
      });
      dispatch(receive(cart));

      setTimeout(() => {
        setBuyButtonState(ButtonStates.Success);

        setTimeout(() => {
          setBuyButtonState(ButtonStates.Default);
        }, 1000);
      }, 800);

      return true;
    } catch (ex) {
      dispatch(catchError(ex, (error) => loadError(error)));
      setBuyButtonState(ButtonStates.Error);

      setTimeout(() => {
        setBuyButtonState(ButtonStates.Default);
      }, 5000);
      return false;
    }
  };

  const handleAddToCart = async () => {
    const qty = parseInt(quantity) || 0;
    if (qty <= 0) return false;
    if (
      isBendix &&
      allowBrokenBox &&
      packageSize > 0 &&
      qty !== confirmedBrokenBoxQty &&
      !clearsRemainingStock(qty)
    ) {
      const roundUp = Math.round(
        Math.ceil(Math.max(packageSize, qty) / packageSize) * packageSize
      );
      if (qty !== roundUp) return false;
    }

    return performAddToCart(qty);
  };

  const handleEnquiry = () => {
    console.log('enquiry'); // TODO ENQUIRY LOGIC
  };

  const AuthenticateButton = () => {
    return (
      <button
        className="authenticate-button"
        onClick={() => dispatch(setLoginModalOpen(true))}
      >
        <Icon name="Person" size={24} className="authenticate-button__icon" />
        {translate('general.signin-or-register')}
      </button>
    );
  };

  return (
    <div className={clsx('buy-button-container', wrapperClassName)}>
      {isAuthenticated ? (
        <>
          {showQuantityInput && (
            <QuantityInput
              quantity={quantity}
              setQuantity={updateQuantity}
              packageSize={packageSize}
              allowBrokenBox={allowBrokenBox}
              stockQuantity={stockQuantity}
              onConfirmBrokenBox={(value) => {
                setConfirmedBrokenBoxQty(value);
                performAddToCart(value);
              }}
            />
          )}
          <BuyButton
            label={buyButtonLabel}
            onClick={handleAddToCart}
            disabled={disabled}
            state={buyButtonState}
            className={buyButtonClassName}
          />
          {/* <EnquiryButton TODO: Add later
            label={enquiryButtonLabel}
            onClick={handleEnquiry}
            state={enquiryButtonState}
          /> */}
          {wishList && (
            <WishListButton articleId={articleNumber} quantity={quantity} />
          )}
        </>
      ) : (
        <AuthenticateButton />
      )}
    </div>
  );
};

export default BuyButtonContainer;
